import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  Select,
  Dialog,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  DialogTitle,
  FormControl,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { FaPaypal, FaRegCreditCard } from "react-icons/fa";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const AutoRenew = () => {
  const [open, setOpen] = useState(false);
  const [msisdn, setmsisdn] = useState("");
  const [cOpen, setCOpen] = useState(false);
  const [data, setData] = useState<any>(null);
  const [action, setAction] = useState(false);
  const [bundle, setBundle] = useState<any>(null);
  const [product, setProduct] = useState<string>("");
  const [detailAction, setDetailAction] = useState(false);
  const [actionRequest, setActionRequest] = useState(false);
  const [bundleDetail, setBundleDetail] = useState<any>(null);

  const baseurl = process.env.REACT_APP_THM_API_URL;

  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (msisdn.trim().length > 9 && product !== "") {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid inputs.");
    }
  };
  const getDetails = async (selectedBundle: any) => {
    getBundleDetail(selectedBundle);
    setBundle(selectedBundle);
    setCOpen(true);
  };

  const getPlanType = (type?: number, category?: number): string => {
    if (type === 1 && category === 1) return "PAYG Plan";
    if (type === 2 && category === 1) return "Monthly Rolling Plan";
    if (type === 2 && category === 6) return "12-month Plan";
    if (type === 2 && category === 5) return "Affiliate Plan";
    if (type === 6 && category === 3) return "Data Plan";
    if (category === 2) return "International Plan";
    return "Plan";
  };

  const getBundleDetail = async (selectedBundle: any) => {
    setDetailAction(true);
    try {
      const res: any = await axiosInterceptorInstance.post(
        `${baseurl}v1/crm/cancel-plan`,
        {
          msisdn: selectedBundle.MSISDN,
          subscriberBundleId: selectedBundle.SubscriberBundleId,
          bundleId: selectedBundle.BundleID.toString(),
        },
      );

      const apiData = res.data.data;
      if (apiData) {
        const refund = apiData.refundDetail;
        const bundle = apiData.bundleDetails;

        const mappedDetail = {
          planName: bundle?.displayName || "-",
          planType: getPlanType(bundle?.type, bundle?.category),
          consumedData: refund?.dataConsume ?? 0,
          consumedMinutes: refund?.minConsume ?? 0,
          consumedSMS: refund?.smsConsume ?? 0,
          totalConsumption: refund?.totalConsume ?? 0,
          planPrice: bundle?.price ?? 0,
          vat: refund?.vat ?? 0,
          lessConsumption: refund?.totalConsumeAmount ?? 0,
          totalRefund: refund?.totalRefundAmount ?? 0,
        };

        setBundleDetail(mappedDetail);
        console.log(bundleDetail);
      }
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setDetailAction(false);
    }
  };

  const refundAmount = async () => {
    toast.dismiss();
    setActionRequest(true);
    try {
      const res: any = await axiosInterceptorInstance.post(
        `${baseurl}v1/crm/refund`,
        {
          msisdn: bundle.MSISDN,
          subscriberBundleId: bundle.SubscriberBundleId,
          DTBundleId: bundle.DTbundleid,
          email: bundle.Email,
        },
      );

      const apiMessage = res.data.message;
      if (apiMessage === "Success") {
        toast.success(apiMessage);
        requestBundles();
        return;
      }
      toast.info(apiMessage);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setOpen(false);
      setCOpen(false);
      setActionRequest(false);
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(`/bundle/list?MSISDN=${msisdn.trim()}&Product=${product}`)
      .then((res: any) => {
        setAction(false);
        const data = JSON.parse(res.data.body);
        if (data.bundles !== null) {
          setData(data.bundles);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  const bundleUpdateRequest = async (
    bundle: any,
    isCancel: boolean = false,
  ) => {
    toast.dismiss();
    setActionRequest(true);
    await axiosInterceptorInstance
      .put(`/bundle/autorenewal`, {
        msisdn: msisdn,
        DTBundleID: bundle.DTbundleid,
        isRenew: bundle.IsRenew,
        isActive: bundle.IsActive,
        product: parseInt(product),
      })
      .then((res: any) => {
        if ((isCancel && bundle.PaymentMethod !== "Paypal") || !isCancel) {
          setOpen(false);
          setCOpen(false);
          setActionRequest(false);
        }

        const data = JSON.parse(res.data.body);
        if (data.Error) {
          toast.error("Error from API");
        } else {
          if (data.message !== "") {
            setOpen(false);
            setCOpen(false);
            setActionRequest(false);
            toast.success(data.message);
            requestBundles();
          } else {
            toast.error("Bundle updation unsucessfull.");
          }
        }
      })
      .catch((error: any) => {
        setOpen(false);
        setCOpen(false);
        setActionRequest(false);
      });
  };

  const unsubPaypal = async (bundle: any) => {
    await axiosInterceptorInstance
      .post("/bundle/paypal/unsubscribe", {
        subscriptionId: bundle.TransactionID,
      })
      .then((res: any) => {
        setOpen(false);
        setCOpen(false);
        setActionRequest(false);
        const data = JSON.parse(res.data.body);
        if (data.Error) {
          toast.error("Error from API");
        } else {
          if (data.status !== null || data.portIn) {
            toast.success("Bundle updated successfully.");
            requestBundles();
          } else {
            toast.error("Bundle updation unsucessfull.");
          }
        }
      })
      .catch((error: any) => {
        setOpen(false);
        setCOpen(false);
        setActionRequest(false);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Bundle Auto Renewal and Cancellation</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4.5}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                defaultValue={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4.5}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ background: "#fff", padding: " 0 5px 0px 0px" }}
                >
                  Product
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="anbu"
                  className="selectControl"
                  autoWidth
                  value={product}
                  defaultValue={product}
                  onChange={(e) => setProduct(e.target.value)}
                >
                  <MenuItem value="">Choose Product</MenuItem>
                  <MenuItem value="1">THM</MenuItem>
                  {/* <MenuItem value="2">Now</MenuItem>
                  <MenuItem value="3">THA</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      {(action || actionRequest) && <div className="diable-bg"></div>}

      {data && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ease: "easeOut", duration: 0.5 }}
        >
          <Grid container spacing={2} height="100%">
            {data?.map((bundle: any, index: number) => {
              return (
                <Grid key={index} item md={6} lg={4} height="100%">
                  <div className="boxShadow m0">
                    <div className="boxInner">
                      <h3
                        className="m0 mb10"
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                          minHeight: "30px",
                        }}
                      >
                        <span>
                          {bundle.Name} - £{bundle.Price}
                        </span>
                        {bundle.PaymentMethod === "Card" && (
                          <span>
                            <FaRegCreditCard
                              style={{ marginTop: "2px" }}
                              size={22}
                            />
                          </span>
                        )}
                        {bundle.PaymentMethod === "Paypal" && (
                          <span>
                            <FaPaypal style={{ marginTop: "2px" }} size={22} />
                          </span>
                        )}
                      </h3>

                      <div className="btnGroup">
                        <Button
                          onClick={() => {
                            setOpen(true);
                            setBundle(bundle);
                          }}
                          className="dButton dButton2"
                          variant="contained"
                        >
                          {bundle.IsRenew ? "Disable" : "Enable"}
                        </Button>
                        {bundle.TransactionID && (
                          <Button
                            className="dButton dButton2"
                            onClick={() => {
                              getDetails(bundle);
                            }}
                            variant="contained"
                          >
                            Cancel
                          </Button>
                        )}
                        {!bundle.TransactionID && (
                          <Button
                            className="dButton dButton2"
                            disabled
                            variant="contained"
                            title="Unable to cancel this bundle"
                          >
                            Cancel
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </motion.div>
      )}
      {bundle && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Bundle Renewal Confirmation"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Would you like to {bundle.IsRenew ? "disable" : "enable"} the auto
              renewal of this bundle?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={() => setOpen(false)}
            >
              Disagree
            </Button>
            <div style={{ width: "30px" }}></div>
            {!actionRequest && (
              <Button
                variant="contained"
                className="dButton dButton2"
                onClick={() => {
                  const objBundle = bundle;
                  objBundle.IsRenew = !bundle.IsRenew;
                  bundleUpdateRequest(objBundle, true);
                }}
                autoFocus
              >
                Agree
              </Button>
            )}
            {actionRequest && (
              <Button className="dButton dButton2" variant="contained">
                <CircularProgress color="inherit" size={30} />
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
      {bundle && (
        <Dialog
          open={cOpen}
          onClose={() => setCOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
            <Typography variant="h6" fontWeight="bold">
              Are you sure you'd like to cancel?
            </Typography>
          </DialogTitle>
          <DialogContent>
            {detailAction && (
              // <Skeleton width="30px" />
              <Box display="flex" justifyContent="center" my={2}>
                <CircularProgress color="inherit" size={30} />
              </Box>
            )}
            {!detailAction && bundleDetail && (
              <>
                <Typography align="center" fontWeight="bold">
                  {bundleDetail.planType}
                </Typography>
                <Typography align="center" color="primary" fontWeight="bold">
                  {bundleDetail.planName}
                </Typography>

                <Box
                  mt={2}
                  border={1}
                  borderColor="#ddd"
                  borderRadius={2}
                  p={2}
                >
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography>Consumed Data</Typography>
                    <Typography>{bundleDetail.consumedData}%</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography>Consumed Minutes</Typography>
                    <Typography>{bundleDetail.consumedMinutes}%</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography>Consumed SMS</Typography>
                    <Typography>{bundleDetail.consumedSMS}%</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Typography fontWeight="700">Total Consumption</Typography>
                    <Typography>{bundleDetail.totalConsumption}%</Typography>
                  </Box>

                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography fontWeight="700">Plan Price</Typography>
                    <Typography fontWeight="700">
                      £{bundleDetail.planPrice}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography color="error">VAT</Typography>
                    <Typography color="error">£{bundleDetail.vat}</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Typography>Less: Consumption</Typography>
                    <Typography>£{bundleDetail.lessConsumption}</Typography>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    fontWeight="bold"
                  >
                    <Typography fontWeight="700">
                      Total Refund Amount:
                    </Typography>
                    <Typography fontWeight="700">
                      £{bundleDetail.totalRefund}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={() => setCOpen(false)}
            >
              Disagree
            </Button>
            <div style={{ width: "30px" }}></div>
            {!actionRequest && (
              <Button
                variant="contained"
                color="secondary"
                className="dButton dButton2"
                onClick={() => {
                  // const objBundle = bundle;
                  // objBundle.IsActive = !bundle.IsActive;
                  // bundleUpdateRequest(objBundle, true);
                  refundAmount();
                }}
                autoFocus
                disabled={detailAction}
              >
                Agree
              </Button>
            )}
            {actionRequest && (
              <Button className="dButton dButton2" variant="contained">
                <CircularProgress color="inherit" size={30} />
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </motion.div>
  );
};

export default AutoRenew;
